export const NAME_APP1 = "ImaDjinn"
export const NAME_APP2 = "ImaDaTa"